import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

const selectBrandOrder = (state: RootState) => state.order;

export const selectBrandOrderSelected = createSelector(selectBrandOrder, (order) => order.brandOrderSelected);
export const selectHasNewOrder = createSelector(selectBrandOrder, (order) => order.hasNewOrder);
